import React, { Component } from "react"
import PropTypes from "prop-types"
import Activate from "components/views/activate/Activate"
import CardStates from "utils/CardStates"
import { connect } from "react-redux"
import { activateCard } from "actions"
import { withRouter } from "react-router-dom"
import { getCardState, getIsActivateError, getIsActivateSubmitting } from "reducers/userInfo"
import { getEmployeeId, getIsCarrotCardEligible } from "../../../reducers/userInfo"

class ActivateContainer extends Component {
  componentDidMount() {
    if (this.props.isCCEligible) {
      if (this.props.cardState !== CardStates.SHIPPED) {
        this.props.history.push("/reimbursements/activate/done")
      }
      if (this.props.cardState == CardStates.SHIPPED) {
        this.props.history.push("/reimbursements/activate")
      }
    } else if (!this.props.isCCEligible) {
      this.props.history.push("/transactions")
    }
  }

  componentDidUpdate(nextProps) {
    if (this.props.cardState !== nextProps.cardState) {
      if (this.props.cardState === CardStates.ACTIVE) {
        this.props.history.push("/reimbursements/activate/success")
      }
    }
  }

  handleSubmit = async (e) => {
    e.preventDefault()
    this.props.activateCard(this.props.employeeId)
  }

  render() {
    return (
      <Activate
        error={this.props.isActivateError}
        onSubmit={this.handleSubmit}
        submitting={this.props.isActivateSubmitting}
      />
    )
  }
}

ActivateContainer.propTypes = {
  isActivateSubmitting: PropTypes.bool.isRequired,
  isActivateError: PropTypes.bool.isRequired,
  cardState: PropTypes.string,
  employeeId: PropTypes.number.isRequired,
  history: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
  isActivateSubmitting: getIsActivateSubmitting(state),
  isActivateError: getIsActivateError(state),
  cardState: getCardState(state),
  employeeId: getEmployeeId(state),
  isCCEligible: getIsCarrotCardEligible(state)
})

ActivateContainer = connect(mapStateToProps, { activateCard })(ActivateContainer)

export default withRouter(ActivateContainer)
